var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.09,
    height: 30.863,
    viewBox: "0 0 25.09 30.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-share",
    "data-name": "Icon feather-share",
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1771",
    "data-name": "Trac\\xE9 1771",
    d: "M6,18V29.545a2.886,2.886,0,0,0,2.886,2.886H26.2a2.886,2.886,0,0,0,2.886-2.886V18",
    transform: "translate(0 -0.569)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1772",
    "data-name": "Trac\\xE9 1772",
    d: "M23.545,8.773,17.773,3,12,8.773",
    transform: "translate(35.318 24.772) rotate(180)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1773",
    "data-name": "Trac\\xE9 1773",
    d: "M18,3V21.761",
    transform: "translate(35.545 24.76) rotate(180)",
    fill: "none",
    stroke: "#3e3e3e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2be24f8d3a8edbd75a2cf45def7d5964.svg";
export { ForwardRef as ReactComponent };